import {lazy} from "react";

export const VideoSingleVoyagesLazy = lazy(() => import('./VideoSingleVoyages'))
